export type AuthMode = 'signup' | 'login' | 'verify' | 'forgot' | 'reset';
export type AuthField = 'email' | 'password' | 'otp';
export type AuthFieldErrors = Partial<Record<AuthField, string>>;

export function validateAuthFields(mode: AuthMode, values: Record<AuthField, string>): AuthFieldErrors {
  const errors: AuthFieldErrors = {};
  if (mode !== 'verify' && mode !== 'reset') {
    const email = values.email.trim();
    if (!email) errors.email = 'Enter your email address to continue.';
    else if (email.length > 254 || !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)*$/.test(email)) {
      errors.email = /\s/.test(email) ? 'Remove the spaces in your email address.' : 'Enter a valid email address, like name@example.com.';
    }
  }
  if (['signup', 'login', 'reset'].includes(mode) && !values.password) errors.password = 'Enter your password to continue.';
  if (['verify', 'reset'].includes(mode) && !/^\d{4}$/.test(values.otp)) errors.otp = 'Enter the 4-digit code from your email.';
  return errors;
}
